import { Box, Skeleton } from '@mui/material';

export default function PendingBadgeLoading() {
  return (
    <Box
      display='flex'
      flexDirection='row'
      alignItems='center'
      gap={0.5}
      bgcolor='#ECECEC'
      borderRadius={12}
      paddingX='12px'
      paddingY='4px'
    >
      <Skeleton variant='circular' width={6} height={6} />
      <Skeleton variant='text' width={60} height={16} sx={{ fontSize: 12 }} />
    </Box>
  );
}
